
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topbusinessquotes",
      function () {
        return require("private-next-pages/topbusinessquotes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topbusinessquotes"])
      });
    }
  